import ArticleSection from 'components/ArticleSection/ArticleSection';
import Title from 'components/Title/Title';
import withArticleQuery, { WithArticleQueryProps } from 'enhancers/withArticleData';
import withArticleId, { IWithArticleIdProps } from 'enhancers/withArticleId';
import withCountry from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';
import Section from 'wrappers/Section/Section';

type Props = WithArticleQueryProps & IWithArticleIdProps & WithLanguageProps;

export const ArticlePage: React.SFC<Props> = props => {
  const background =
    !props.loading &&
    props.data &&
    props.data.fetch.Common &&
    props.data.fetch.Common.Articles &&
    props.data.fetch.Common.Articles.Background
      ? props.data.fetch.Common.Articles.Background
      : '#ffffff';
  const color = getTextColor(background);
  return (
    <Container style={{ background, color }}>
      {!props.loading &&
        props.data &&
        props.data.fetch.Country.HomePage &&
        props.data.fetch.Country.HomePage.NewsSection &&
        props.data.fetch.Country.HomePage.NewsSection.Article && (
          <Section>
            <StyledTitle>
              {props.getText(
                props.data.fetch.Country.HomePage.NewsSection.Article.Title
              )}
            </StyledTitle>
            <Content>
              {props.data.fetch.Country.HomePage.NewsSection.Article.Content &&
                props.data.fetch.Country.HomePage.NewsSection.Article.Content.map(
                  (content, i) => <ArticleSection key={i} {...content} />
                )}
            </Content>
          </Section>
        )}
    </Container>
  );
};

const StyledTitle = styled(Title)`
  text-align: center;
  margin-top: 0;
`;

const Container = styled.div`
  padding-top: 25px;
`;

const Content = styled.div``;

export default withLanguageState(
  withArticleId(withCountry(withArticleQuery(ArticlePage)))
);



// WEBPACK FOOTER //
// ./src/pages/ArticlePage/ArticlePage.tsx